export const getStyles = (color?: string) => {
  if (color === 'blue') {
    return {
      variant: 'primary',
      color: 'blue',
    } as const;
  }

  return {
    variant: 'outlined',
    color: 'dark',
  } as const;
};
